import { Component, Input, OnInit, inject } from '@angular/core';
import {Address} from '../../../data/models/address.model';
import {Person} from '../../../data/models/person.model';
import {TranslationService} from '../../services/translation.service';
import {HouseNoPipe} from "../../pipes/houseno.pipe";

@Component({
  selector: 'app-address-detail',
  templateUrl: './address-detail.component.html',
  styleUrls: ['./address-detail.component.scss'],
  imports: [
    HouseNoPipe
  ],
  standalone: true
})
export class AddressDetailComponent implements OnInit {
  translationService = inject(TranslationService);

  @Input() address: Address;
  @Input() person: Person;

  ngOnInit(): void {
  }

  joinParts(parts: (string | undefined)[], separator: string = ' '): string {
    return parts.filter(part => part !== null && part !== undefined && part !== '').join(separator);
  }

}
